if (!customElements.get('video-grid-overview')) {
  class VideoGridOverview extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
    }

    connectedCallback() {
      this.initDurations();
    }

    initDurations() {
      this.querySelectorAll('.js-video-grid-duration').forEach((durationEl) => {
        const videoType = durationEl.dataset.videoType || '';
        const manualDuration = durationEl.dataset.durationManual || '';

        if (videoType === 'hosted') {
          const hostedSrc = durationEl.dataset.videoSrc;
          if (hostedSrc) {
            this.resolveHostedDuration(hostedSrc).then((seconds) => {
              if (Number.isFinite(seconds) && seconds > 0) {
                durationEl.textContent = this.formatDuration(seconds);
              } else if (manualDuration) {
                durationEl.textContent = manualDuration;
              }
            });
            return;
          }
        }

        if (manualDuration) {
          durationEl.textContent = manualDuration;
        }
      });
    }

    resolveHostedDuration(src) {
      return new Promise((resolve) => {
        const probe = document.createElement('video');
        probe.preload = 'metadata';
        probe.muted = true;
        probe.src = src;

        const clear = () => {
          probe.removeAttribute('src');
          probe.load();
        };

        probe.addEventListener('loadedmetadata', () => {
          const seconds = Math.round(probe.duration || 0);
          clear();
          resolve(seconds);
        }, { once: true });

        probe.addEventListener('error', () => {
          clear();
          resolve(null);
        }, { once: true });
      });
    }

    formatDuration(totalSeconds) {
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (hours > 0) {
        return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      }

      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }

    handleClick(evt) {
      const opener = evt.target.closest('.js-video-grid-open');
      if (!opener) return;

      const modalId = opener.dataset.modalId;
      const videoType = opener.dataset.videoType || 'external';
      const videoSrc = opener.dataset.videoSrc;
      if (!modalId) return;

      const modal = this.querySelector(`#${modalId}`);
      if (!modal) return;

      if (videoType === 'hosted') {
        const video = modal.querySelector('.op-video-grid__native-video');
        if (!video) return;

        video.currentTime = 0;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
        return;
      }

      if (!videoSrc) return;

      const iframe = modal.querySelector('.op-video-grid__iframe');
      if (!iframe) return;

      iframe.src = '';
      iframe.setAttribute('src', videoSrc);
    }
  }

  customElements.define('video-grid-overview', VideoGridOverview);
}
